import { useEffect, useRef, useState } from "react"
import { createPortal } from "react-dom"
import { useNavigate } from "react-router-dom"
import { ClientApi } from "../../services/clientApi"
import { NuiMessages } from "../../utils/ClientEvents"
import { Preloader } from "./Preloader"

export const PreloadOverlay = () => {
    const [visible, setVisible] = useState(true)
    const navigate = useNavigate()
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
    const pageOnFinishRef = useRef<string | null>(null)

    const checkStorage = () => {
        const shouldHide = !!localStorage.getItem("shouldHidePreloader")
        if (shouldHide) {
            setVisible(false)
        }
    }

    useEffect(() => {

        const clearFallbackTimer = () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current)
                timerRef.current = null
            }
        }

        const finish = () => {
            setVisible(false)
            if (pageOnFinishRef.current) navigate(pageOnFinishRef.current)
        }

        ClientApi.on(NuiMessages.PRELOADER, ({ duration, pageOnFinish }: { duration: number | null, pageOnFinish: string | null }) => {
            pageOnFinishRef.current = pageOnFinish ?? null
            clearFallbackTimer()
            setVisible(true)
            if (typeof duration === 'number') {
                timerRef.current = setTimeout(finish, duration)
            }
        })

        ClientApi.on(NuiMessages.PRELOADER_HIDE, () => {
            clearFallbackTimer()
            finish()
        })

        checkStorage()

        return clearFallbackTimer
    }, [navigate])

    if (!visible) return null

    return createPortal(
        <div style={{ position: 'fixed', inset: 0, zIndex: 2147483647 }}>
            <Preloader />
        </div>,
        document.body
    )
}
